<template>
    <option value="utc">UTC</option>

    <option value="" disabled>United States:</option>
    <option value="America/New_York">US Eastern</option>
    <option value="America/Chicago">US Central</option>
    <option value="America/Denver">US Mountain</option>
    <option value="America/Los_Angeles">US Pacific</option>
    <option value="America/Puerto_Rico">US Atlantic (PR)</option>

    <option value="" disabled>Canada:</option>
    <option value="America/Halifax">CA Atlantic</option>
    <option value="America/Toronto">CA Eastern</option>
    <option value="America/Winnipeg">CA Central</option>
    <option value="America/Regina">CA Central (no DST)</option>
    <option value="America/Edmonton">CA Mountain</option>
    <option value="America/Whitehorse">CA Mountain (no DST)</option>
    <option value="America/St_Johns">CA Newfoundland</option>
    <option value="America/Vancouver">CA Pacific</option>   

    <option value="" disabled>Australia:</option>
    <option value="Australia/Sydney">AU Eastern</option>
    <option value="Australia/Brisbane">AU Eastern (no DST)</option>
    <option value="Australia/Adelaide">AU Central</option>
    <option value="Australia/Darwin">AU Central (no DST)</option>
    <option value="Australia/Perth">AU West (no DST)</option>

    <option value="" disabled>Other:</option>
    <option value="Asia/Baghdad">Iraq / AST</option>
</template>
